import { useContext } from 'react';

import { HoneycombOverlayRefContext } from '../contexts/HoneycombOverlayRefContext.js';

export const useHoneycombOverlayRef = () => {
  const context = useContext(HoneycombOverlayRefContext);
  if (!context) {
    throw new Error(
      '"useHoneycombOverlayRef" needs to be used under "HoneycombOverlayRefContext.Provider"',
    );
  }
  return context;
};
